import styled from 'styled-components';

export const TagsContainer = styled('div')`
    max-width: 2000px;
    padding: 40px 100px 40px;
    min-width: 1224px;
`;
